import React from 'react';

import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { ImplicitAuthWidget } from 'containers/ImplicitAuthWidget';

export const PartnerRegistrationManagerAuthForm = () => {
  const dispatch = useAppDispatcher();

  const handleEmailConfirmed = React.useCallback(() => {
    dispatch({
      name: 'PartnerRegistrationManager__EmailConfirmed',
    });
  }, [dispatch]);

  return (
    <ImplicitAuthWidget
      target="PARTNER"
      onEmailConfirmed={handleEmailConfirmed}
    />
  );
};
